import { render, staticRenderFns } from "./PromotionsTenantProfile.vue?vue&type=template&id=01d46646&scoped=true&"
import script from "./PromotionsTenantProfile.vue?vue&type=script&lang=js&"
export * from "./PromotionsTenantProfile.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsTenantProfile.vue?vue&type=style&index=0&id=01d46646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d46646",
  null
  
)

export default component.exports